import { HttpErrorResponse } from '@angular/common/http';
import { ProblemDetail } from '../models/http-response-error.model';

export function fieldErrorsOf<F extends string>(error: unknown, fields: readonly F[]): Partial<Record<F, string>> {
  if (!(error instanceof HttpErrorResponse) || error.status !== 400) {
    return {};
  }

  const validationErrors = (error.error as Partial<ProblemDetail> | null)?.validationErrors ?? [];
  const errors: Partial<Record<F, string>> = {};

  for (const validationError of validationErrors) {
    const field = fields.find(candidate => candidate === validationError.field);
    if (field && validationError.message) {
      errors[field] = asSentence(validationError.message);
    }
  }

  return errors;
}

function asSentence(message: string): string {
  const sentence = message.charAt(0).toLocaleUpperCase('pt-BR') + message.slice(1);
  return sentence.endsWith('.') ? sentence : `${sentence}.`;
}
